import React from "react";

type Props = {
    label?: string;
    description?: string;
};

export default function Toggle(props: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & Props) {
    const { label } = props;

    return (
        <label className="inline-flex cursor-pointer items-center">
            <input
                {...props}
                type="checkbox"
                className="peer sr-only"
            />
            <div
                className="peer relative h-6 min-w-11 rounded-full bg-gray-200 after:absolute after:start-[2px] after:top-[2px] after:size-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-blue-600 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rtl:peer-checked:after:-translate-x-full dark:border-gray-600 dark:bg-gray-700 dark:peer-focus:ring-blue-800"
            />
            <div className={"flex flex-col"}>
                <span dangerouslySetInnerHTML={{ __html: label }} className="ms-3 text-sm font-medium text-textColor"/>
                {/*<span*/}
                {/*    className="ms-3 text-xs font-medium text-gray-500 "*/}
                {/*>*/}
                {/*        {description}*/}
                {/*    </span>*/}
            </div>
        </label>
    );
}